var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5625 19.9238C2.54688 19.9238 1.7819 19.6699 1.26758 19.1621C0.753255 18.6608 0.496094 17.9056 0.496094 16.8965V5.64648C0.496094 4.63737 0.753255 3.88216 1.26758 3.38086C1.7819 2.87305 2.54688 2.61914 3.5625 2.61914H14.627L13.0547 4.19141H3.5918C3.10352 4.19141 2.72591 4.32161 2.45898 4.58203C2.19857 4.84245 2.06836 5.22656 2.06836 5.73438V16.8184C2.06836 17.3262 2.19857 17.7103 2.45898 17.9707C2.72591 18.2246 3.10352 18.3516 3.5918 18.3516H15.0078C15.3464 18.3516 15.6328 18.2246 15.8672 17.9707C16.1081 17.7103 16.2285 17.3262 16.2285 16.8184V7.44336L17.8008 5.87109V16.8965C17.8008 17.9056 17.5566 18.6608 17.0684 19.1621C16.5866 19.6699 15.9062 19.9238 15.0273 19.9238H3.5625ZM7.11719 13.5957C7.02604 13.6348 6.94141 13.6152 6.86328 13.5371C6.79167 13.4525 6.77539 13.3678 6.81445 13.2832L7.69336 11.4473L16.8047 2.33594L18.1426 3.6543L9.02148 12.7656L7.11719 13.5957ZM18.8652 2.94141L17.5273 1.59375L18.2402 0.890625C18.403 0.734375 18.5885 0.64974 18.7969 0.636719C19.0117 0.623698 19.194 0.692057 19.3438 0.841797L19.5684 1.07617C19.7376 1.23893 19.819 1.42773 19.8125 1.64258C19.8125 1.85091 19.7311 2.04297 19.5684 2.21875L18.8652 2.94141Z",
    fill: "#1A1717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.521ad7feafa2af4554373f75aba676b0.svg";
export { ForwardRef as ReactComponent };